module.exports = __webpack_public_path__ + "img/logo.5b67d11f.svg";